import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LocationsHero } from '../components/locations/LocationsHero';
import { LocationGrid } from '../components/locations/LocationGrid';
import { CTASection } from '../components/home/CTASection';
export function LocationsPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-823">
      <Header data-id="element-824" />

      <main className="pt-20" data-id="element-825">
        <LocationsHero data-id="element-826" />
        <LocationGrid data-id="element-827" />
        <CTASection data-id="element-828" />
      </main>

      <Footer data-id="element-829" />
    </div>;
}